import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='who-we-are'
      backgroundVariant='lightC'
      advisorImageVariant='advisorB'
      headingText={<>Ready to feel better <WidowBlock>about your finances&#63;</WidowBlock></>}
      text='Your advisor is here to help make it happen and guide you every step of the way.'
    />
  );
};
